import GET_ROLES from '../graphql/SubUsers/getRoles.gql';
import DELETE_SUB_USER from '../graphql/SubUsers/deleteSubUser.gql';
import ADD_SUB_USER from '../graphql/SubUsers/addSubUser.gql';
import UPDATE_SUB_USER from '../graphql/SubUsers/updateSubUser.gql';
import GET_PERMISSIONS from '../graphql/SubUsers/getPermissions.gql';
import {authClient, graphClient} from '../main';

export default class SubUsersResource {

    async getRoles () {
        return await graphClient.query({
            query: GET_ROLES,
            update: data => data.me
        })
    }

    async getPermissions () {
        return await graphClient.query({
            query: GET_PERMISSIONS,
            update: data => data.me
        })
    }

    async create(User) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: ADD_SUB_USER,
            variables: {
                email: User.email,
                'first_name': User.firstName,
                'last_name' : User.lastName,
                password: User.password,
                phone: User.phone,
                role: User.role,
                specific_permissions: JSON.stringify(User.specific_permissions)
            }
        })
    }

    async update(User) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_SUB_USER,
            variables: {
                id: User.id,
                email: User.email,
                first_name: User.first_name,
                last_name: User.last_name,
                phone: User.phone,
                role: User.role,
                specific_permissions: JSON.stringify(User.specific_permissions)
            }
        })
    }

    async delete(id) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: DELETE_SUB_USER,
            variables: {
                id: id,
            }
        })
    }
}
